import { schema } from 'normalizr';

export const projectItem = new schema.Entity(
  'projects',
  {},
  {
    idAttribute: 'objectId',
  },
);